import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

// import Logo from "assets/images/satyamTours.svg";
import Canada from "assets/images/canada.png";
import India from "assets/images/india.png";
import Netherlands from "assets/images/netherlands.png";
import Turkey from "assets/images/turkey.png";
import Uk from "assets/images/united-kingdom.png";
import Unt from "assets/images/unt.png";
import Usa from "assets/images/usa.png";

import Partner1 from "assets/images/Partner1.svg";
import Partner2 from "assets/images/anvrLogo.svg";
import Partner4 from "assets/images/iata-logo-vector.svg";
import Partner3 from "assets/images/sgrLogo.svg";

import { ReactComponent as Logo } from "assets/images/satyamTours.svg";
import {
  getUserFromLocalStorage,
  removeUserFromLocalStorage,
} from "hooks/LocalStorage";
import { useTranslation } from "i18n";

import { CurrencyContext } from "pages/useContext";
import "./style.css";

import FlightIcon from "@mui/icons-material/Flight";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import Button from "../button";
import LangsModal from "./currency-languages-modal";
import Drawer from "./header-drawer";
import HeaderMobileDrawer from "./navigation-drawer";
import { paths } from "./paths";

import { Typography } from "@mui/material";
import { getFlag } from "utils/Currency&Language";

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  width: { xs: "90%", md: "550px" },
  p: 4,
  "&:focus": {
    outline: "none",
  },
};

const Header = ({ handelOpenSignUp, handleCloseSignUp, ...props }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [show, setShow] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [mobileOpenDrawer, setOpenMobileDrawer] = useState(false);
  const { language, t } = useTranslation();

  const handelCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handelCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleOpenMobileDrawer = () => {
    setOpenMobileDrawer(true);
  };

  const handleCloseMobileDrawer = () => {
    setOpenMobileDrawer(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const { currency, setCurrency } = useContext(CurrencyContext);

  const handleClose = () => {
    setOpen(false);

    handleCloseSignUp();

    setSelected(null);
  };

  let navigate = useNavigate();

  const [user, setUser] = useState({});

  const logOut = () => {
    navigate(0);

    removeUserFromLocalStorage();
    setShow(false);
  };

  window.addEventListener("storage", () => {
    setUser(getUserFromLocalStorage());
  });

  useEffect(() => {
    window.dispatchEvent(new Event("storage"));
  }, []);

  return (
    <>
      <HideOnScroll {...props}>
        <nav className="navbar navbar-expand-lg navbar-light">
          <Box display="flex" width="100%" className="navbar-inner" mr={{ xs: 2, md: 4 }}>
            <Box
              display="flex"
              alignItems="center"
              className="navbar-brand-lockup"
            >
              <Link className="navbar-brand mx-0" to="/">
                <Logo className="logo-svg" />
              </Link>
            </Box>

            <Box
              display={{ xs: "none", lg: "flex" }}
              component="ul"
              className="navbar-nav navbar-links mb-0"
            >
              {paths.map((path) => (
                <li className="nav-item" key={path.path}>
                  <NavLink
                    to={path.path}
                    end={path.path === "/"}
                    className="nav-link"
                    onClick={() => setShow(false)}
                  >
                    {t(path.labelKey)}
                  </NavLink>
                </li>
              ))}
            </Box>
            {/* <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => setShow((prev) => !prev)}
            >
              <span className="navbar-toggler-icon"></span>
            </button> */}
            <Box
              display="flex"
              alignItems="center"
              className="navbar-nav-cluster"
            >
              <Box
                display={{ xs: "flex", lg: "none" }}
                alignItems="center"
                className="navbar-mobile-trigger"
                onClick={handleOpenMobileDrawer}
              >
                <FlightIcon fontSize={"small"} />
                {mobileOpenDrawer ? (
                  <KeyboardArrowUpIcon fontSize={"small"} />
                ) : (
                  <KeyboardArrowDownIcon fontSize={"small"} />
                )}
              </Box>

              <Box
                display={{ xs: "none", lg: "flex" }}
                alignItems="center"
                className="navbar-tools"
              >
                <Box className="partners-logo-header">
                  <img src={Partner4} alt="IATA" />
                  <img src={Partner2} alt="ANVR" />
                  <img src={Partner1} alt="Partner" />
                  <img src={Partner3} alt="SGR" />
                </Box>
                <Box
                  className="nav-item dropdown"
                  display="flex"
                  alignItems="center"
                >
                  <Box onClick={handleOpenModal} className="navbar-lang-chip">
                    <Box display="flex" alignItems="center">
                      {getFlag(currency?.currency)}
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.75}>
                      <Typography variant="subtitle2">
                        {language?.language}
                      </Typography>
                      <Box
                        component="span"
                        sx={{
                          width: "1px",
                          height: 14,
                          bgcolor: "rgba(18,40,70,0.15)",
                        }}
                      />
                      <Typography variant="subtitle2">
                        {currency?.currency}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {user ? (
                <>
                  <Box ml={{ xs: "auto", lg: "0px" }}>
                    <li className="nav-item dropdown ">
                      <Box
                        className="navbar-user-chip"
                        justifyContent="center"
                        onClick={handleOpenDrawer}
                      >
                        <Avatar
                          sx={{
                            background:
                              "linear-gradient(135deg, #f15e22 0%, #ff8a4c 100%)",
                            fontSize: "12px",
                            fontWeight: 700,
                            width: 30,
                            height: 30,
                          }}
                        >
                          {user?.firstName?.charAt()}
                          {user?.lastName?.charAt()}
                        </Avatar>
                        <MenuIcon sx={{ color: "#374151", fontSize: 20 }} />
                      </Box>
                      <ul
                        className="dropdown-menu right-dropdown"
                        aria-labelledby="navbarDropdown"
                      >
                        <li>
                          <Link
                            to="/my-account/profile"
                            onClick={() => setShow(false)}
                            className="dropdown-item"
                          >
                            {t("navigation.myAccount")}
                          </Link>
                        </li>

                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li onClick={logOut}>
                          <a className="dropdown-item" href="#">
                            {t("navigation.logOut")}
                          </a>
                        </li>
                      </ul>
                    </li>
                  </Box>
                </>
              ) : (
                <Box
                  className="navbar-auth-actions"
                  ml={{ xs: "auto", lg: "16px" }}
                >
                  <Button
                    onClick={() => {
                      window.location.hash = "auth-required";
                    }}
                    className="main-booking-btn primary-color"
                    type="submit"
                  >
                    <LockOpenIcon className="me-1" /> {t("navigation.logIn")}
                  </Button>

                  <Button
                    onClick={() => {
                      handelOpenSignUp(true);
                    }}
                    className="main-booking-btn"
                    type="submit"
                  >
                    <HowToRegIcon className="me-1" /> {t("navigation.signUp")}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </nav>
      </HideOnScroll>

      <Drawer
        handleOpenModalLangs={handleOpenModal}
        open={openDrawer}
        onCloseDrawer={handelCloseDrawer}
      />

      <HeaderMobileDrawer
        open={mobileOpenDrawer}
        onCloseDrawer={handleCloseMobileDrawer}
      />

      <LangsModal
        onHandleChangeCurrentCurrency={setCurrency}
        open={openModal}
        currentCurrency={currency}
        onCloseModal={handelCloseModal}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <p className="medium-font-size">{t("navigation.chooseCountry")}</p>
          <Box py={2}>
            {[
              "USA",
              "DUBAI",
              "INDIA",
              "TURKEY",
              "NETHERLANDS",
              "CANADA",
              "UNITED KINGDOM",
            ].map((item, index) => (
              <Box
                key={index}
                borderRadius="6px"
                px={1.5}
                py={0.5}
                mb={1.5}
                border="1px solid rgb(232, 237, 241)"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className={`box-country ${selected === item && "active"}`}
                onClick={() => setSelected(item)}
              >
                <Box display="flex" alignItems="center">
                  {index === 0 ? (
                    <img src={Usa} alt="flag" />
                  ) : index === 1 ? (
                    <img src={Unt} alt="flag" />
                  ) : index === 2 ? (
                    <img src={India} alt="flag" />
                  ) : index === 3 ? (
                    <img src={Turkey} alt="flag" />
                  ) : index === 4 ? (
                    <img src={Netherlands} alt="flag" />
                  ) : index === 5 ? (
                    <img src={Canada} alt="flag" />
                  ) : (
                    <img src={Uk} alt="flag" />
                  )}

                  <p className="bold mx-2">{item}</p>
                </Box>

                <Radio checked={item === selected} />
              </Box>
            ))}
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button onClick={handleClose}>{t("common.cancel")}</Button>
            <Button
              onClick={() => {
                navigate(`/visa/${selected.toLowerCase()}`);
                setOpen(false);
              }}
              className="primary-color"
              disabled={!selected}
            >
              {t("common.select")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Header;
